import { memo } from 'react'
import ChevronIcon from './ChevronIcon'
import { cn } from '@/lib/utils'

const StageHeader = memo(({ 
    stage, 
    collapsedStages, 
    toggleStageCollapse, 
    audienceCount, 
    availableStages, 
    isFirstStage, 
    toggleAllStages, 
    areAllStagesCollapsed 
}) => {
    const isDisabled = !availableStages.includes(stage.id)

    return (
        <div className="tw:flex tw:items-center tw:justify-between tw:px-4">
            <div className="tw:inline-flex tw:gap-2 tw:items-center">
                <button
                    onClick={() => toggleStageCollapse(stage.id)}
                    className="tw:flex tw:items-center tw:justify-center hover:tw:bg-gray-700 tw:rounded tw:transition-colors"
                    type="button"
                >
                    <div className={cn(
                        'tw:w-5 tw:h-5 tw:flex tw:items-center tw:justify-center',
                        isDisabled && 'tw:hidden'
                    )}>
                        <ChevronIcon isCollapsed={collapsedStages.has(stage.id)} />
                    </div>
                </button>

                {isDisabled && <div className="tw:size-3 tw:rounded-full tw:border-2"></div>}
                {!isDisabled && <div className="tw:size-3 tw:rounded-full" style={{ backgroundColor: stage.color }} />}

                <span className="tw:font-semibold tw:text-white">{stage.name}</span>
                {!isDisabled && (
                    <span className="tw:bg-[#263E57] tw:text-white tw:rounded-full tw:px-2 tw:py-1 tw:text-xs tw:font-medium">
                        {audienceCount}
                    </span>
                )}
            </div>

            {isFirstStage && (
                <button
                    onClick={toggleAllStages}
                    className="tw:text-[#3871FF] tw:text-sm tw:font-normal hover:tw:text-[#3871FF]/80 tw:transition-colors"
                >
                    {areAllStagesCollapsed ? 'Expand All' : 'Collapse All'}
                </button>
            )}
        </div>
    )
})

StageHeader.displayName = 'StageHeader'

export default StageHeader